import React, { useState, useEffect } from 'react';
import ReactDropdown from 'react-dropdown';
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { endOfMonth, startOfMonth, startOfYear, endOfYear, setMonth, setYear } from 'date-fns';

const customStyles = `
  .two-column-menu {
      display: grid !important;
      grid-template-columns: 1fr 1fr;
      width: 320px !important; 
      padding: 5px !important;
      gap: 5px;
      max-height: 400px !important;
      overflow-y: auto;
  }
  .two-column-menu .option-all {
      grid-column: 1 / -1;
      border-bottom: 2px solid #f1f1f1;
      font-weight: bold;
      color: #007bff;
      text-align: center;
      margin-bottom: 5px;
      padding: 10px;
  }

  .two-column-menu .Dropdown-option {
      padding: 8px 10px;
      font-size: 13px;
      border-radius: 4px;
      cursor: pointer;
  }

  .two-column-menu .Dropdown-option:hover {
      background-color: #e3f2fd;
      color: #007bff;
  }
  
  .two-column-menu .Dropdown-option.is-selected {
      background-color: #007bff;
      color: #fff;
  }
  .two-column-menu .option-empty {
      pointer-events: none;
      visibility: hidden;
      height: 0;
      padding: 0 !important;
      margin: 0;
  }
  .two-column-menu::before {
      content: "Tháng";
      grid-column: 1;
      grid-row: 2;
      font-weight: bold;
      color: #858796;
      font-size: 11px;
      text-transform: uppercase;
      padding-left: 10px;
  }
  .two-column-menu::after {
      content: "Quý";
      grid-column: 2;
      grid-row: 2;
      font-weight: bold;
      color: #858796;
      font-size: 11px;
      text-transform: uppercase;
      padding-left: 10px;
  }
`;

const generateTimeOptions = () => {
    const options = [
        { value: 'all', label: 'Tất cả', className: 'option-all' }
    ];
    for (let i = 1; i <= 12; i++) {
        options.push({ 
            value: `M${i}`, 
            label: `Tháng ${i}`, 
            className: 'option-month' 
        });
        if (i <= 4) {
            options.push({ 
                value: `Q${i}`, 
                label: `Quý ${i}`, 
                className: 'option-quarter' 
            });
        } else {
            options.push({ 
                value: 'empty', 
                label: '', 
                className: 'option-empty' 
            });
        }
    }
    return options;
};

const flatTimeOptions = generateTimeOptions();

const yearOptions = [
    ...Array.from({ length: new Date().getFullYear() - 2010 + 1 }, (_, i) => ({
        value: new Date().getFullYear() - i,
        label: `${new Date().getFullYear() - i}`
    }))
];

export const SearchBarLoiNhuan = ({ onApply }) => {
    const currentYear = new Date().getFullYear();
    
    const [filters, setFilters] = useState({
        timeValue: 'all',
        year: currentYear,
        dtFrom: null,
        dtTo: null,
    });
    const calculateDates = (timeVal, yearVal) => {
        let from, to;
        const baseDate = setYear(new Date(), yearVal);

        if (timeVal === 'all') {
            from = startOfYear(baseDate);
            to = endOfYear(baseDate);
        } else if (timeVal.startsWith('M')) {
            const monthIndex = parseInt(timeVal.substring(1)) - 1;
            const dateInMonth = setMonth(baseDate, monthIndex);
            from = startOfMonth(dateInMonth);
            to = endOfMonth(dateInMonth);
        } else if (timeVal.startsWith('Q')) {
            const quarterIndex = parseInt(timeVal.substring(1));
            const startMonthIndex = (quarterIndex - 1) * 3;
            const endMonthIndex = startMonthIndex + 2;
            from = startOfMonth(setMonth(baseDate, startMonthIndex));
            to = endOfMonth(setMonth(baseDate, endMonthIndex));
        }
        return { from, to };
    };

    const handleDropdownChange = (field) => (selectedOption) => {
        const value = selectedOption.value;
        if (value === 'empty') return;

        setFilters(prev => ({
            ...prev,
            [field]: value,
            dtFrom: null, 
            dtTo: null
        }));
    };

    const handleDateChange = (field) => (date) => {
        setFilters(prev => ({
            ...prev,
            [field]: date,
            timeValue: 'all'
        }));
    };

    const handleSubmit = (e) => {
        if (e) e.preventDefault();

        let dateToSendFrom = filters.dtFrom;
        let dateToSendTo = filters.dtTo;
        const isCustom = !!(filters.dtFrom && filters.dtTo);

        if (!isCustom) {
            const calculated = calculateDates(filters.timeValue, filters.year);
            dateToSendFrom = calculated.from;
            dateToSendTo = calculated.to;
        }

        onApply({
            dtFrom: dateToSendFrom,
            dtTo: dateToSendTo,
            timeValue: filters.timeValue,
            year: filters.year,
            isCustom
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <style>{customStyles}</style>

            <div className="search-new d-flex flex-row align-items-end justify-content-start gap-3 flex-wrap">
                <div className="input-sm-new" style={{ minWidth: '220px' }}>
                    <label className="font-color-default font-bold">Lựa chọn tháng hoặc quý</label>
                    <ReactDropdown
                        options={flatTimeOptions}
                        onChange={handleDropdownChange('timeValue')}
                        value={flatTimeOptions.find(opt => opt.value === filters.timeValue)}
                        placeholder="Chọn thời gian"
                        controlClassName="form-control input-sm"
                        menuClassName="two-column-menu" 
                    />
                </div>

                <div className="input-sm-new" style={{ minWidth: '100px' }}>
                    <label className="font-color-default font-bold">Năm</label>
                    <ReactDropdown
                        options={yearOptions}
                        onChange={handleDropdownChange('year')}
                        value={yearOptions.find(opt => opt.value === filters.year)}
                        placeholder="Chọn năm"
                        controlClassName="form-control input-sm"
                    />
                </div>

                <div className="input-sm-new" style={{ flex: 1, minWidth: '120px' }}>
                    <label className="font-color-default font-bold">Từ ngày</label>
                    <DateTimePicker
                        value={filters.dtFrom}
                        onChange={handleDateChange("dtFrom")}
                        placeholder="Chọn ngày"
                    />
                </div>

                <div className="input-sm-new" style={{ flex: 1, minWidth: '120px' }}>
                    <label className="font-color-default font-bold">Đến ngày</label>
                    <DateTimePicker
                        value={filters.dtTo}
                        onChange={handleDateChange("dtTo")}
                        placeholder="Chọn ngày"
                    />
                </div>

                <div className="input-sm-new mt-1">
                    <button type="submit" className="btn btn-info-new" style={{ paddingTop: "7px" }}>
                        <i className="la la-search"></i> Tìm kiếm
                    </button>
                </div>
            </div>
        </form>
    );
};